<script>
import { checkConsentMixin } from './check-consent-mixin'
import loadScript from './load-script'

export default {
  mixins: [checkConsentMixin],

  props: {
    appHostname: {
      type: String,
      required: true
    }
  },

  methods: {
    trackPage() {
      loadScript(`//${this.appHostname}/piwik.js`)
    }
  }
}
</script>
